var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.normalizedName
    ? _c(
        "v-icon",
        {
          staticClass: "material-symbols-outlined custom-page-icon",
          attrs: {
            size: _vm.size,
            "aria-hidden": _vm.label ? null : "true",
            "aria-label": _vm.label,
            role: _vm.label ? "img" : null
          }
        },
        [_vm._v(" " + _vm._s(_vm.normalizedName) + " ")]
      )
    : _c("portal-icon", {
        attrs: { name: "file-text", size: _vm.size, label: _vm.label }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }